export default {
  EMPLOYE_PROFIL: 'employes',
  USER_PROFIL: 'system_users',
};
